import React from "react";
import type { OccupancyCalendarProps as OccupancyCalendarComponentProps } from "../OccupancyCalendar";
import OccupancyCalendarComponent from "../OccupancyCalendar";

type OccupancyCalendarProps = {
  occupancyWindowUrl: OccupancyCalendarComponentProps["occupancyWindowUrl"];
  templateUrl: OccupancyCalendarComponentProps["templateUrl"];
  monthsCount: OccupancyCalendarComponentProps["monthsCount"];
};

export default function OccupancyCalendar({ occupancyWindowUrl, templateUrl, monthsCount }: OccupancyCalendarProps) {
  return (
    <React.StrictMode>
      <OccupancyCalendarComponent
        occupancyWindowUrl={occupancyWindowUrl}
        templateUrl={templateUrl}
        monthsCount={monthsCount}
      ></OccupancyCalendarComponent>
    </React.StrictMode>
  );
}
